const TableNoteNoData = () => {
    return <p className='text-[36px] font-bold text-[#818181] my-[12px]'>データがありません</p>
}

export default TableNoteNoData